import { useState } from 'react';

import { toast } from 'react-toastify';

import useConnectWallet from '@/store/wallet/useConnectWallet';

import useListenerTransfer from './useListenerTransfer';

/**
 * useSwap 是一个自定义 Hook，用于执行基于 Uniswap 路由合约的代币兑换逻辑。
 * 支持 "带转账手续费" 的代币（例如 USDT、SHIB 等）。
 */
const useSwap = (successFun?: Function, errorFun?: Function) => {
    // 从钱包状态中获取路由合约（routerAbi）和用户钱包地址
    const { contractEvm: { router } } = useConnectWallet();
    const { address } = useConnectWallet();

    // 控制加载状态（是否正在交易中）
    const [swapLod, setLoading] = useState(false);
    // 获取监听交易完成事件的函数
    const listenerTransferF = useListenerTransfer();

    /**
     * swap 函数执行代币兑换。
     * 
     * @param amountIn - 用户输入的兑换代币数量（BigInt，单位是最小精度，例如 1e18）
     * @param amountOutMin - 用户可接受的最小接收数量（防滑点保护）
     * @param tokenAddressFrom - 要出售的代币地址
     * @param tokenAddressTo - 要购买的代币地址
     * @param deadline - 交易截止时间（单位：秒，通常是 block.timestamp + 300）
     * @param toastText - 可选的通知文本，格式：{ success: string, error: string }
     */
    const swap = async (
        amountIn: bigint,
        amountOutMin: bigint,
        path: string[],
        deadline: bigint,
        toastText?: { success: string, error: string }
    ) => {
        // 确保路由合约已经连接
        if (router) {
            setLoading(true); // 开始加载状态
            try {
                console.log(amountIn, amountOutMin, path, deadline);
                // 调用路由合约的 swapExactTokensForTokensSupportingFeeOnTransferTokens 方法进行兑换
                const { hash } = await router.swapExactTokensForTokensSupportingFeeOnTransferTokens(
                    amountIn,
                    amountOutMin,
                    path, // path
                    address, // 收款地址
                    deadline
                );

                // 监听交易完成事件
                const relset = await listenerTransferF(hash);

                if (relset) {
                    // 成功回调
                    toastText && toast.success(toastText.success);
                    successFun && successFun();
                } else {
                    // 失败回调
                    toastText && toast.error(toastText.error);
                    errorFun && errorFun();
                }
            } catch (error) {
                // 捕获异常并打印日志
                console.error('交易出错:', error);
                toastText && toast.error(toastText.error);
            }

            // 恢复加载状态
            setLoading(false);
        }
    };
    return {
        swap,      // 发起兑换交易的方法
        swapLod,   // 当前是否处于加载状态
    };
};

export default useSwap;